import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'itl-listitem-top-header',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListitemTopHeaderComponent {}
